module.exports = __webpack_public_path__ + "img/logo-thin-orrm-light.9114f0ac.svg";